module.exports = __webpack_public_path__ + "static/media/basket.bfa986cb.png";